exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item .error-message[data-v-d79350f4] {\n  color: red;\n}\n\n", ""]);

// exports
